// extracted by mini-css-extract-plugin
module.exports = {"headlineSection":"styles_headlineSection__8Fi9P","textContent":"styles_textContent___FBfk","title":"styles_title__ga8cG","line":"styles_line__RgzoL"};